import { NgModule } from '@angular/core';
import { DiscoverCoreModule } from './Core/discover-core.module';
import { DiscoverComponent } from './Core/components/Discover/discover.component';
import { DiscoverRoutingModule } from './DiscoverRouter/discover-routing.module';
import { DiscoverTargetingModule } from './Targeting/discover-targeting.module';
import { LocalizationModule } from '../Core/Localization/localization.module';
import { CommonFormsModule } from '../Common/Forms/forms.module';


@NgModule({
    imports: [
        DiscoverCoreModule,
        DiscoverRoutingModule,
        DiscoverTargetingModule,
        LocalizationModule,
        CommonFormsModule
    ],
    exports: [
        DiscoverComponent
    ]
})
export class DiscoverModule { }
